
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { helpStyles } from '../../Styles/dialogStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import StepConnector from '@material-ui/core/StepConnector';
 import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import SaveIcon from '@material-ui/icons/Save';
import BackupIcon from '@material-ui/icons/Backup';
const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundColor: '#1077ff',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundColor: '#1077ff'

    },
});

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundColor: '#1077ff'

        },
    },
    completed: {
        '& $line': {
            backgroundColor: '#1077ff'
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
        1: <ReactSVG src={Images.navTemplate} />,
        2: <ReactSVG src={Images.visibilityIcon} />,
        3: <SettingsIcon />,
        4: <SaveIcon />,
        5: <BackupIcon/>
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

@inject('commonStore')
@observer
class InitialHelpDialog extends React.Component {

    state = {
        steps: [
            {
                id: 1,
                label: 'Select document',
                desc: 'In the onboarding screen, choose from the list of sample documents provided.'
            },
            {
                id: 2,
                label: 'Preview',
                desc: 'Once the desired sample is clicked, you will have a preview of how the document has been processed. You can click on the fields on the left side, to view how it is being extracted from the image on the right.'
            },
            {
                id: 3,
                label: 'Configure',
                desc: 'Click on "Proceed to Mapping".In the mapping stage, you can rename the labels for the identified fields, choose the fields you want to extract, and re-arrange them as desired. '
            },
            {
                id: 4,
                label: 'Save',
                desc: `Click on 'Next' to save your configuration`
            },
            {
                id: 5,
                label: 'Upload',
                desc: `Click on "Import" to begin uploading your documents`
            }

        ],
        activeStep: 0
    }

    handleClose = () => {
        this.props.commonStore.openHelpDialog(false);
        this.setState({
            activeStep: 0
        })
    }

    onClickBack = () => {
        if (this.state.activeStep === 0)
            return
        else
            this.setState({
                activeStep: this.state.activeStep - 1
            })
    }

    onClickNext = () => {
        if (this.state.activeStep === this.state.steps.length-1)
            this.handleClose()
        else
            this.setState({
                activeStep: this.state.activeStep + 1
            })

    }


    render() {
        const { helpDialog } = this.props.commonStore;
        const { classes, theme } = this.props;
        const { steps, activeStep } = this.state;
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }}
                disableBackdropClick={false} disableEscapeKeyDown={false} classes={{ paper: classes.helpDialog }} open={helpDialog} aria-labelledby="form-dialog-title" onClose={this.handleClose} >
                <DialogTitle>
                    <Typography className={classes.dialogHeading}>Onboarding Guide</Typography>
                    <Typography className={classes.dialogSubHeading}>Follow the step-wise guide to understand the onboarding process.</Typography>
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography className={classes.stepHeading}>{steps[activeStep].desc}</Typography>


                        <Stepper style={{ backgroundColor: theme.palette.dark, color: 'white' }} alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                            {steps.map((item, index) => (
                                <Step key={item.id}>
                                    <StepLabel classes={{
                                        label: classes.stepInactive,
                                        active: classes.stepActive,
                                        completed: classes.completed


                                    }}
                                        StepIconComponent={ColorlibStepIcon}>{item.label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <div>
                            <Button style={{ backgroundColor: '#acb4c6' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.onClickBack()}>
                                Prev
                        </Button>

                            <Button variant="contained" className={classes.button} type="submit" onClick={(e) => this.onClickNext()}>
                                {activeStep === steps.length-1 ? 'Finish' : 'Next'}
                        </Button>
                        </div>

                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}

InitialHelpDialog.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(helpStyles, { withTheme: true })(withRouter(InitialHelpDialog));
